module.exports = __webpack_public_path__ + "img/result2.01962d95.png";